/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/calendar': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g class="nc-icon-wrapper" _fill="#272c33"><path pid="0" d="M15 2h-2V0h-2v2H9V0H7v2H5V0H3v2H1a1 1 0 00-1 1v12a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1zm-1 12H2V5h12v9z"/><path pid="1" data-color="color-2" d="M4 7h2v2H4zM7 7h2v2H7zM4 10h2v2H4zM7 10h2v2H7zM10 7h2v2h-2zM10 10h2v2h-2z"/></g>'
  }
})
